import React from "react";
import classNames from "classnames";

/**
 * @typedef {object} Props
 * @property {"0-5" | "2" | "4"} [gap]
 * @property {boolean} [vertical]
 */

/** @type {React.FunctionComponent<Props>} */
const Grid = ({ children, gap, vertical }) => {
  return (
    <div
      className={classNames("grid", {
        [`grid--gap-${gap}`]: gap,
        [`grid--vertical`]: vertical,
      })}
    >
      {children}
    </div>
  );
};

export default Grid;
